export default "__VITE_ASSET__CK6chw1L__"